import { create } from "zustand";
import { remoteConfigService } from "../services/remote-config";
import { registerRemoteConfigService } from "@repo/utils";

interface FeatureState {
  isInitialized: boolean;
  vertical: string;
  flags: Record<string, any>;
  overrides: Record<string, any>;
  init: () => Promise<void>;
  setVertical: (vertical: string) => Promise<void>;
  updateFlags: () => void;
  setOverride: (key: string, value: any) => void;
  clearOverrides: () => void;
}

export const useFeatureStore = create<FeatureState>((set, get) => ({
  isInitialized: false,
  vertical: "learn",
  flags: {},
  overrides: JSON.parse(localStorage.getItem("ff_overrides") || "{}"),

  updateFlags: () => {
    const remoteFlags = remoteConfigService.getAllValues();
    const overrides = get().overrides;
    set({ flags: { ...remoteFlags, ...overrides } });
  },

  init: async () => {
    try {
      registerRemoteConfigService(remoteConfigService);
      await remoteConfigService.initialize();
      await remoteConfigService.fetchAndActivate();
      get().updateFlags();
    } catch (error) {
      console.error("FeatureStore: failed to initialize", error);
    } finally {
      set({ isInitialized: true });
    }
  },

  setVertical: async (vertical: string) => {
    try {
      await remoteConfigService.setUserProperty("user_vertical", vertical);
      await remoteConfigService.fetchAndActivate();
      set({ vertical });
      get().updateFlags();
    } catch (error) {
      console.error("FeatureStore: failed to update vertical", error);
    }
  },

  setOverride: (key: string, value: any) => {
    const newOverrides = { ...get().overrides, [key]: value };
    localStorage.setItem("ff_overrides", JSON.stringify(newOverrides));
    set({ overrides: newOverrides });
    get().updateFlags();
  },

  clearOverrides: () => {
    localStorage.removeItem("ff_overrides");
    set({ overrides: {} });
    get().updateFlags();
  },
}));
